import { render, staticRenderFns } from "./clientProfileConfiguration.vue?vue&type=template&id=b6b6285e&scoped=true"
import script from "./clientProfileConfiguration.vue?vue&type=script&lang=js"
export * from "./clientProfileConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b6285e",
  null
  
)

export default component.exports